/* Cuurve — show product videos with the right colour.
   The theme groups photos by file name (e.g. Cosy-Charlotte-DarkOlive-16.jpg -> "DarkOlive").
   Videos have no file name in Liquid, so their group is blank and they get hidden.
   This reads the colour from the video's cover image name instead
   (e.g. Cosy-Charlotte-DarkOlive-video.jpg) and shows the video with that colour.
*/
(() => {
  const DELIMITER = '-';
  const POSITION = 3; // 1-indexed: Cosy=1, Charlotte=2, DarkOlive=3

  function groupFromSrc(src) {
    if (!src) return '';
    const file = src.split('?')[0].split('/').pop();
    const parts = file.split(DELIMITER);
    return parts.length > POSITION ? parts[POSITION - 1] : '';
  }

  function isVideoItem(el) {
    return !!el.querySelector('deferred-media, video, .deferred-media, .thumbnail__badge');
  }

  function fixVideos() {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.groupVariants !== 'true') return;
      if (gallery.dataset.disableImageGrouping === 'true') return;

      const items = Array.from(gallery.querySelectorAll('.product__media-item, .thumbnail-list__item'));

      // current colour = the active (featured) main image's group
      const active =
        items.find((el) => el.classList.contains('product__media-item') && el.classList.contains('is-active') && el.dataset.variantGrouping) ||
        items.find((el) => el.classList.contains('product__media-item') && !el.classList.contains('hide-image') && el.dataset.variantGrouping);
      const current = active ? active.dataset.variantGrouping : '';
      if (!current) return;

      items.forEach((el) => {
        if (!isVideoItem(el)) return;
        if (!el.dataset.variantGrouping) {
          const img = el.querySelector('img');
          const group = groupFromSrc(img && (img.getAttribute('src') || img.currentSrc));
          if (!group) return;
          el.dataset.variantGrouping = group;
        }
        el.classList.toggle('hide-image', el.dataset.variantGrouping !== current);
      });
    });
  }

  function run() {
    setTimeout(fixVideos, 0);
    setTimeout(fixVideos, 300);
  }

  document.addEventListener('DOMContentLoaded', () => {
    run();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, run);
    }
  });
  document.addEventListener('shopify:section:load', run);
})();
